export default "__VITE_ASSET__CLnELScL__"